import { render, staticRenderFns } from "./DQ.vue?vue&type=template&id=6a09ad24&scoped=true&"
import script from "./DQ.vue?vue&type=script&lang=js&"
export * from "./DQ.vue?vue&type=script&lang=js&"
import style0 from "./DQ.vue?vue&type=style&index=0&id=6a09ad24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09ad24",
  null
  
)

export default component.exports